const filmProjects = [
  {
    title: "Into the Shadows (Short Film)",
    description: "Credited as Social Media Editor. Produced fan-edit style reels/TikToks from film footage to align with dystopian themes and drive online engagement.",
    image: "/assets/film/Into the Shadows.jpg",
    embedUrl: "https://www.instagram.com/p/C_qsZc9NIQX/embed",
    links: [
      { label: "Watch Film", url: "https://www.youtube.com/watch?v=dERotVauy5k" },
    ]
  },
  
  {
    title: "Social Media Content Creator",
    description: "Built a YouTube channel with 2.5K+ subscribers and 1M+ total views and expanded cross-platform reach (IG 800+, TikTok 100+).",
    image: "/assets/film/helarious.png",
    links: [
      { label: "YouTube", url: "https://www.youtube.com/@helarious" },
      { label: "Instagram", url: "https://www.instagram.com/panikacake/" },
      { label: "TikTok", url: "https://www.tiktok.com/@he.larious" }
    ]
  },
  {
    title: "Freelance Video Editor",
    description: "Editing short-form video content for creators and brands.",
    image: "/assets/film/freelance.png",
    embedUrl: "https://www.instagram.com/reel/DQzlt3YEa_S/embed/",
  },
  {
    title: "Scream (OT7's Version)",
    description: "A comedic parody script reimagining Scream as a Christmas slasher set in New York City, starring my friends.",
    image: "/assets/film/Scream.png",
    embedUrl: "https://drive.google.com/file/d/1W9MhNOAfdMrsSDeEhM8aC50h_ZZORc8t/preview",
    links: [
      { label: "Read Script", url: "https://docs.google.com/document/d/12ivYrz0k293XBm9cCyCbskskl3D4byhwbh_HomtWhYQ/edit?usp=sharing" }
    ]
  }
];

export default filmProjects;
